/* eslint-disable react/prop-types */
import React from 'react';

import TagTabs from '@/components/Tabs/TagTabs';

function AttachmentTabs({ tabs }) {
  const [activeTab, setActiveTab] = React.useState('summary');
  const onChangeTab = tab => {
    setActiveTab(tab);
  };

  return <TagTabs tabs={tabs} activeTab={activeTab} onChangeTab={onChangeTab} />;
}

export default AttachmentTabs;
